import { createFileRoute } from '@tanstack/react-router'
import { TicketListView } from '@/features/ticket-list/TicketListView'
import { useViewAsId } from '@/lib/viewAs'

function Inbox() {
  return <TicketListView asUser={useViewAsId()} />
}

export const Route = createFileRoute('/tickets/')({ component: Inbox })
